$(document).ready(function () {
    if (!$('#carousel-marquee-style').length) {
        $('head').append(`
            <style id="carousel-marquee-style">
                @keyframes carouselMarquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(var(--scroll-distance)); }
                }
            </style>
        `);
    }

    setTimeout(function() {
        const carousels = []; // Store marquee data
        const speed = 100; // px/s



        function setupCarousel($container) {
            const $carousel = $container.find('.carousel');
            const $items = $carousel.find('.carousel-item');
            const originalItems = $items.toArray();

            // Clean marquee before cloning
            $carousel.empty();
            originalItems.forEach(item => $carousel.append($(item)));

            let totalWidth = 0;
            let originalWidth = 0;

            // Measure original width with sub-pixel precision to avoid "flash" jump
            originalItems.forEach(item => {
                const rect = item.getBoundingClientRect();
                const style = window.getComputedStyle(item);
                const margin = (parseFloat(style.marginLeft) || 0) + (parseFloat(style.marginRight) || 0);
                originalWidth += rect.width + margin;
            });

            // Clone until the total width is at least 2x the container
            while (totalWidth < 2 * $container.width()) {
                originalItems.forEach(item => {
                    $carousel.append($(item).clone());
                });
                totalWidth = 0;
                $carousel.find('.carousel-item').each(function () {
                    totalWidth += $(this).outerWidth(true);
                });
            }

            const duration = originalWidth / speed;

            // Optimize performance with CSS animations (GPU)
            $carousel.css('will-change', 'transform');
            $carousel[0].style.setProperty('--scroll-distance', `-${originalWidth}px`);
            $carousel.css('animation', `carouselMarquee ${duration}s linear infinite`);



            // Save marquee data
            carousels.push({
                $container,
                $carousel,
                originalItems
            });
        }

        // Initialize all marquees
        $('.carousel-container').each(function () {
            setupCarousel($(this));
        });

        // Debounce for resize
        let resizeTimeout;
        $(window).on('resize', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                const oldCarousels = [...carousels];
                carousels.length = 0;
                
                // Clean and reset marquees
                oldCarousels.forEach(data => {
                    const { $container, $carousel, originalItems } = data;
                    $carousel.css('animation', 'none');
                    $carousel.empty();
                    originalItems.forEach(item => $carousel.append($(item)));
                    setupCarousel($container);
                });
            }, 300);
        });
    }, 600);
});